import { AuthService } from './auth.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { exhaustMap, take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

export class SiteUser{
  token:string;
  /**
   * class for the logged in user credentials"token for now".
   */
  constructor(token:string) {
    this.token=token;
  }
}

@Injectable({
  providedIn:"root"
})
export class AuthInterceptorService implements HttpInterceptor{
  //used for the http interceptor to better capture the user details.
 siteUser=new BehaviorSubject<SiteUser>(null);
  /**
   * Used to add the token to any request.
   */
  constructor() {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token=localStorage.getItem('accessToken');
    const user=new SiteUser(token);
    this.siteUser.next(user);

    return this.siteUser.pipe(take(1),exhaustMap(user=>{
      if(!user.token){
        return next.handle(req);
      }
      //const requestHeader:HttpHeaders=new HttpHeaders({'token':user.token});
      //const modifiedRequest=req.clone({setHeaders:{'token':user.token}});
      const queryParams:HttpParams=new HttpParams().set('token',user.token);
      const modifiedRequest=req.clone({params:queryParams});
      return next.handle(modifiedRequest);
    }))
  }


}
